import { render, staticRenderFns } from "./CreateOrderButton.vue?vue&type=template&id=591792a7"
import script from "./CreateOrderButton.vue?vue&type=script&lang=js"
export * from "./CreateOrderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports